// src/pages/HesapSilme.jsx
import LegalLayout from "../components/LegalLayout";

export default function HesapSilme() {
  return (
    <LegalLayout
      title="Hesap Silme Talebi"
      updatedAt="20.01.2026"
      subtitle="Bu sayfa, KolayYük uygulamasında hesap silme ve ilişkili verilerin silinmesiyle ilgili talimatları içerir. Bu bağlantı Google Play mağaza girişinde görüntülenebilir."
    >
      {/* 1 */}
      <Section title="1. Hesap silme adımları">
        <p className={styles.p}>
          KolayYük hesabınızın silinmesini talep etmek için aşağıdaki yöntemlerden birini kullanabilirsiniz:
        </p>

        <ul className={styles.ul}>
          <li className={styles.li}>
            <strong>Uygulama üzerinden:</strong> Profil / Hesabım bölümüne gidin ve{" "}
            <strong>“Hesabımı Sil”</strong> seçeneğini kullanın.
          </li>
          <li className={styles.li}>
            <strong>E-posta ile:</strong> Kayıtlı telefon numaranızı belirterek{" "}
            <a className={styles.a} href="mailto:info@kolayyuk.com">
              info@kolayyuk.com
            </a>{" "}
            adresine “Hesap Silme Talebi” konulu bir e-posta gönderin.
          </li>
        </ul>

        <p className={styles.p}>
          Hesap silme talepleri, güvenlik amacıyla kimlik doğrulaması gerektirebilir. (Örn. hesapla ilişkili
          telefon numarasının teyidi.)
        </p>
      </Section>

      {/* 2 */}
      <Section title="2. Silinen veri türleri">
        <p className={styles.p}>
          Hesap silme talebiniz işleme alındığında, aşağıdaki veri türleri kalıcı olarak silinir:
        </p>

        <ul className={styles.ul}>
          <li className={styles.li}>
            <strong>Kimlik/Profil Bilgileri:</strong> ad, soyad
          </li>
          <li className={styles.li}>
            <strong>İletişim Bilgileri:</strong> telefon numarası, (varsa) e-posta
          </li>
          <li className={styles.li}>
            <strong>Hesap Bilgileri:</strong> kullanıcı kimliği (uid) ve profil kaydı
          </li>
          <li className={styles.li}>
            <strong>İçerik Verileri:</strong> ilanlarınız, teklifleriniz ve destek talepleriniz (varsa ekleri)
          </li>
          <li className={styles.li}>
            <strong>Yüklenen Belgeler:</strong> taşıyıcı profili için yüklediğiniz belgeler (varsa)
          </li>
        </ul>
      </Section>

      {/* 3 */}
      <Section title="3. Saklanan veriler ve saklama süreleri">
        <p className={styles.p}>
          Yasal yükümlülükler kapsamında bazı kayıtlar belirli sürelerle saklanabilir. Bu veriler aktif
          kullanımda tutulmaz ve yalnızca mevzuatın gerektirdiği durumlarda saklanır.
        </p>

        <ul className={styles.ul}>
          <li className={styles.li}>
            <strong>Finansal/faturalama kayıtları</strong> (varsa): en fazla <strong>10 yıl</strong>
          </li>
          <li className={styles.li}>
            <strong>Hukuki yükümlülük gerektiren işlem kayıtları:</strong> ilgili mevzuatta öngörülen süre boyunca
          </li>
        </ul>

        <p className={styles.p}>
          KolayYük; kredi kartı verisi veya biyometrik veri işlemez.
        </p>
      </Section>

      {/* 4 */}
      <Section title="4. Hesabı silmeden veri silme (kısmi silme)">
        <p className={styles.p}>
          Kullanıcılar, hesaplarını tamamen silmeden de belirli kişisel verilerinin silinmesini talep edebilir.
          Kısmi silme taleplerinizi{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>{" "}
          adresine iletebilirsiniz. Talebinizde kayıtlı telefon numaranızı ve hangi verilerin silinmesini
          istediğinizi belirtmeniz yeterlidir.
        </p>
      </Section>

      {/* 5 */}
      <Section title="5. İletişim">
        <p className={styles.p}>
          Hesap silme ve kişisel verilerle ilgili tüm talepler için:{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl font-extrabold text-black">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

const styles = {
  p: "text-gray-700 leading-relaxed mt-3",
  ul: "mt-3 ml-5 list-disc text-gray-700 leading-relaxed",
  li: "mt-2",
  a: "text-black underline underline-offset-4",
};
